import { useQueryParam, withDefault } from "use-query-params";

import { CustomJsonCompressedParam } from "@north-beam/nb-common";

type SelectionState = {
  selectedRowIds: string[];
  deselectedRowIds: string[];
};

const SelectionStateParam = CustomJsonCompressedParam<SelectionState>();

const _usePerformanceTrackingTableSelectionState = () =>
  useQueryParam(
    "table-selection",
    withDefault(SelectionStateParam, {
      selectedRowIds: [],
      deselectedRowIds: [],
    }),
    {
      updateType: "pushIn",
    },
  );

export const usePerformanceTrackingTableSelectionState = () => {
  const [selectionState, setSelectionState] =
    _usePerformanceTrackingTableSelectionState();

  return [selectionState, setSelectionState] as const;
};
